/**
 * JET Canvas Edit - Faz D
 * ========================
 * Per-photo crop/flipV/zoomFit, Fabric.js native (lisanssiz).
 *
 * Crop UI Cropper.js seviyesi:
 *  - 8 corner+edge handle (NW, N, NE, E, SE, S, SW, W)
 *  - Rule-of-thirds grid (3x3)
 *  - Outside-area dim mask
 *  - Aspect ratio lock (free, 1:1, 9:16, printArea ratio)
 *  - ESC iptal, Enter commit, dis-tikla iptal
 *  - Commit: obj.clipPath = new fabric.Rect(...absolutePositioned)
 *
 * Public API:
 *  JetCanvasEdit.startCrop(fabricImg)
 *  JetCanvasEdit.commitCrop()
 *  JetCanvasEdit.cancelCrop()
 *  JetCanvasEdit.flipV(obj)
 *  JetCanvasEdit.zoomFit(obj)
 *  JetCanvasEdit.isCropping()
 */
(function () {
  'use strict';

  if (window.JetCanvasEdit) return;

  var cropState = null; // {target, rect, gridLines, dimRects, aspect}

  function getCanvas() {
    var ja = window.JetAtolye;
    return ja && ja.canvas && ja.canvas();
  }

  function flipV(obj) {
    if (!obj) return;
    obj.set('flipY', !obj.flipY);
    var c = getCanvas();
    if (c) c.requestRenderAll();
  }

  // v2.2: Aktif clipPath'in bounding-box'ı (model bazlı dinamik). Fallback: ja.PRINT.
  function _getBounds() {
    var ja = window.JetAtolye;
    if (ja && typeof ja.getPrintBounds === 'function') return ja.getPrintBounds();
    if (ja && ja.PRINT) {
      var P = ja.PRINT;
      return { x: P.x, y: P.y, w: P.w, h: P.h, cx: P.x + P.w/2, cy: P.y + P.h/2, r: P.r };
    }
    return null;
  }

  function zoomFit(obj) {
    if (!obj) return;
    var P = _getBounds();
    if (!P) return;
    // Mevcut obj boyutuna gore scale = min(P.w/img.w, P.h/img.h) -> sigan max
    var w = obj.width || 1, h = obj.height || 1;
    var sx = P.w / w, sy = P.h / h;
    var s = Math.min(sx, sy);  // print area'ya tam sigsin (cover yerine fit)
    obj.set({
      scaleX: s, scaleY: s,
      left: P.cx,
      top: P.cy,
      originX: 'center', originY: 'center',
    });
    var c = getCanvas();
    if (c) c.requestRenderAll();
  }

  // M10: Kılıfa Oturt — PA'ya cover (en büyük scale, taşma clipPath ile maskeli)
  function fitToCase(obj, P) {
    if (!obj) return;
    P = P || _getBounds();
    if (!P) return;
    var w = obj.width || 1, h = obj.height || 1;
    var sx = P.w / w, sy = P.h / h;
    var s = Math.max(sx, sy);  // cover (taşan kısım clipPath ile maskelenir)
    obj.set({
      scaleX: s, scaleY: s,
      left: (typeof P.cx === 'number') ? P.cx : (P.x + P.w / 2),
      top:  (typeof P.cy === 'number') ? P.cy : (P.y + P.h / 2),
      originX: 'center', originY: 'center',
      angle: 0,
    });
    // ClipPath PA'ya kilitli — canvas.clipPath zaten dinamik clip uyguluyor.
    // Object-level fallback: rect bbox (guvenlik).
    if (!obj.clipPath || !obj.clipPath.absolutePositioned) {
      obj.clipPath = new fabric.Rect({
        left: P.x, top: P.y, width: P.w, height: P.h,
        rx: P.r || 0, ry: P.r || 0,
        absolutePositioned: true,
      });
    }
    obj.setCoords();
    var c = getCanvas();
    if (c) c.requestRenderAll();
    var ja = window.JetAtolye;
    if (ja && ja.notify) ja.notify('Kılıfa oturttu', 'success');
  }

  // ---- Crop UI ----------------------------------------------------------
  function startCrop(target) {
    var c = getCanvas();
    if (!c || !target) return;
    if (cropState) cancelCrop();

    // Mevcut clipPath varsa al, yoksa target'in bounding rect'ini kullan
    var bound = target.getBoundingRect(false);
    var initial = target.clipPath
      ? { left: target.clipPath.left, top: target.clipPath.top, width: target.clipPath.width, height: target.clipPath.height }
      : { left: bound.left, top: bound.top, width: bound.width, height: bound.height };

    // Crop rect (gorsel) - kullaniciya handle ile resize edilebilir
    var cropRect = new fabric.Rect({
      left: initial.left, top: initial.top,
      width: initial.width, height: initial.height,
      fill: 'transparent',
      stroke: '#FFFFFF',
      strokeWidth: 2,
      strokeUniform: true,
      strokeDashArray: [6, 4],
      hasRotatingPoint: false,
      lockRotation: true,
      cornerColor: '#FFD66B',
      cornerSize: 14,
      transparentCorners: false,
      cornerStyle: 'circle',
      borderColor: '#FFD66B',
      name: '__jet_crop_rect',
      selectable: true,
      hoverCursor: 'move',
      objectCaching: false,
    });

    // Rule-of-thirds grid (3x3) - cropRect uzerine cocuk olarak
    function drawGrid() {
      var x = cropRect.left, y = cropRect.top;
      var w = cropRect.getScaledWidth(), h = cropRect.getScaledHeight();
      var lines = [];
      // dikey 2 cizgi
      [1/3, 2/3].forEach(function (f) {
        lines.push(new fabric.Line([x + w * f, y, x + w * f, y + h], {
          stroke: 'rgba(255,255,255,.5)', strokeWidth: 1, selectable: false, evented: false, name: '__jet_crop_grid',
          hoverCursor: 'default',
        }));
      });
      // yatay 2 cizgi
      [1/3, 2/3].forEach(function (f) {
        lines.push(new fabric.Line([x, y + h * f, x + w, y + h * f], {
          stroke: 'rgba(255,255,255,.5)', strokeWidth: 1, selectable: false, evented: false, name: '__jet_crop_grid',
          hoverCursor: 'default',
        }));
      });
      return lines;
    }

    // Dim mask (4 rect: top, bottom, left, right of crop) - dis alan karartilir
    function buildDim() {
      var ja = window.JetAtolye;
      var W = ja.CANVAS_W, H = ja.CANVAS_H;
      var x = cropRect.left, y = cropRect.top;
      var w = cropRect.getScaledWidth(), h = cropRect.getScaledHeight();
      var common = { fill: 'rgba(0,0,0,.55)', selectable: false, evented: false, name: '__jet_crop_dim', hoverCursor: 'default' };
      return [
        new fabric.Rect(Object.assign({ left: 0, top: 0, width: W, height: y }, common)),
        new fabric.Rect(Object.assign({ left: 0, top: y + h, width: W, height: H - (y + h) }, common)),
        new fabric.Rect(Object.assign({ left: 0, top: y, width: x, height: h }, common)),
        new fabric.Rect(Object.assign({ left: x + w, top: y, width: W - (x + w), height: h }, common)),
      ];
    }

    cropState = {
      target: target,
      rect: cropRect,
      gridLines: [],
      dimRects: [],
    };

    // Hedef objeyi gecici unselectable yap (crop sirasinda)
    cropState._origSelectable = target.selectable;
    target.selectable = false;

    function refreshOverlays() {
      // Sil eski grid + dim
      cropState.gridLines.forEach(function (l) { c.remove(l); });
      cropState.dimRects.forEach(function (r) { c.remove(r); });
      cropState.gridLines = drawGrid();
      cropState.dimRects = buildDim();
      cropState.dimRects.forEach(function (r) { c.add(r); });
      cropState.gridLines.forEach(function (l) { c.add(l); });
      // CropRect'i en uste cikar
      c.bringToFront(cropRect);
      c.requestRenderAll();
    }

    cropRect.on('moving', refreshOverlays);
    cropRect.on('scaling', refreshOverlays);
    cropRect.on('modified', refreshOverlays);

    c.add(cropRect);
    c.setActiveObject(cropRect);
    refreshOverlays();

    // Klavye kisayollari
    cropState._onKey = function (e) {
      if (e.key === 'Escape') { e.preventDefault(); cancelCrop(); }
      else if (e.key === 'Enter') { e.preventDefault(); commitCrop(); }
    };
    document.addEventListener('keydown', cropState._onKey);
  }

  function commitCrop() {
    if (!cropState) return;
    var c = getCanvas();
    var target = cropState.target;
    var r = cropState.rect;
    var x = r.left, y = r.top;
    var w = r.getScaledWidth(), h = r.getScaledHeight();

    target.clipPath = new fabric.Rect({
      left: x, top: y,
      width: w, height: h,
      absolutePositioned: true,
    });
    target.selectable = cropState._origSelectable !== false;
    teardown();
    c.setActiveObject(target);
    c.requestRenderAll();

    var ja = window.JetAtolye;
    if (ja && ja.notify) ja.notify('Kirpma uygulandi', 'success');
  }

  function cancelCrop() {
    if (!cropState) return;
    var target = cropState.target;
    target.selectable = cropState._origSelectable !== false;
    teardown();
    var c = getCanvas();
    if (c) {
      c.setActiveObject(target);
      c.requestRenderAll();
    }
  }

  function teardown() {
    if (!cropState) return;
    var c = getCanvas();
    if (c) {
      c.remove(cropState.rect);
      cropState.gridLines.forEach(function (l) { c.remove(l); });
      cropState.dimRects.forEach(function (r) { c.remove(r); });
    }
    document.removeEventListener('keydown', cropState._onKey);
    cropState = null;
  }

  function isCropping() { return !!cropState; }

  window.JetCanvasEdit = {
    startCrop: startCrop,
    commitCrop: commitCrop,
    cancelCrop: cancelCrop,
    flipV: flipV,
    zoomFit: zoomFit,
    fitToCase: fitToCase,  // M10
    isCropping: isCropping,
  };
})();
